import { fetchApiActionsDescriptionAudiosList } from 'openapi/client/actions/detail-description-audios';

import fetcher from '../utils/api';
import { captureSentryError } from '../utils/SentryHelper';

const actionsService = {
  getActions: async (
    scribeDocumentId,
    skip = 0,
    limit = 20,
    actionIds = [],
    fetchUntilElementWithHash = undefined,
    isAuthenticated = true,
    version_id = undefined
  ) => {
    try {
      return await fetcher(
        `scribe_documents/${scribeDocumentId}/actions?skip=${skip}&limit=${limit}${
          actionIds.length > 0 ? `&actionIds=${actionIds.join(',')}` : ''
        }${fetchUntilElementWithHash ? `&until_hash=${fetchUntilElementWithHash}` : ''}${version_id ? `&version_id=${version_id}` : ''}`,
        'GET',
        isAuthenticated,
        {}
      );
    } catch (error) {
      captureSentryError(error, {
        tags: { action: 'getActions' },
        level: 'error',
        contexts: { scribeDocumentId, skip, limit, actionIds, fetchUntilElementWithHash, isAuthenticated }
      });
      throw error;
    }
  },
  reorderActions: async (scribeDocumentId, actionsOrder) => {
    try {
      return await fetcher(`scribe_documents/${scribeDocumentId}/reorder_actions`, 'POST', true, {
        actions_order: actionsOrder
      });
    } catch (error) {
      captureSentryError(error, {
        tags: { action: 'reorderActions' },
        level: 'error',
        contexts: { scribeDocumentId, actionsOrder }
      });
      throw error;
    }
  },
  addLegacyComment: async (actionId, content, commentUserId) => {
    try {
      return await fetcher(`actions/${actionId}/comments/`, 'POST', true, {
        action: actionId,
        content,
        comment_user_id: commentUserId
      });
    } catch (error) {
      captureSentryError(error, {
        tags: { action: 'addLegacyComment' },
        level: 'error',
        contexts: { actionId, content, commentUserId }
      });
      throw error;
    }
  },
  deleteComment: async (commentId, deletionToken) => {
    try {
      return await fetcher(`comments/${commentId}/${deletionToken ? `?deletion_token=${deletionToken}` : ''}`, 'DELETE', true);
    } catch (error) {
      captureSentryError(error, {
        tags: { action: 'deleteComment' },
        level: 'error',
        contexts: { commentId, deletionToken }
      });
      throw error;
    }
  },
  getMouseScreenshot: async (actionId, isAuthenticated = true) => {
    try {
      return await fetcher(`actions/${actionId}/download_mouse_screenshot`, 'GET', isAuthenticated);
    } catch (error) {
      captureSentryError(error, {
        tags: { action: 'getMouseScreenshot' },
        level: 'error',
        contexts: { actionId, isAuthenticated }
      });
      throw error;
    }
  },
  getActionDescriptionAudioList: async (actionId, isAuthenticated = true) => {
    try {
      return await fetchApiActionsDescriptionAudiosList({ pathParams: { id: actionId }, isAuthenticated });
    } catch (error) {
      captureSentryError(error, {
        tags: { action: 'getActionDescriptionAudioList' },
        level: 'error',
        contexts: { actionId }
      });
      throw error;
    }
  }
};

export default actionsService;
